import React from "react";

import { Fill, Track, Value, Wrap } from "./styles";

interface PercentBarProps {
    percent: number;
}

/*
* Доля с полоской. Своя, а не MUI LinearProgress: фичи в MUI не ходят, а для кита это пока
* деталь одного экрана — уедет туда, когда понадобится во второй фиче.
* */
export const PercentBar = ({ percent }: PercentBarProps) => {
    // Полоску держим в пределах шкалы: доля больше ста процентов означала бы, что итог периода
    // и выборка топа посчитаны по разным заказам, но верстку это ронять не должно.
    const bounded = Math.max(0, Math.min(100, percent));

    return (
        <Wrap>
            <Value>{percent.toFixed(1)} %</Value>
            <Track>
                <Fill $percent={bounded} />
            </Track>
        </Wrap>
    );
};
